import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../Constants/index";
import {
  APP_LINKS,
  isShortCode,
  onThisSite,
  safeShortLinkTarget,
  shortLinkLeavesSite,
  withShortLinkTracking,
} from "../components/applinks/applinks.mjs";
import { isArabic, replaceLocation } from "../components/applinks/browserstate";
import OpenInApp from "./openinapp.pages";
import "../components/applinks/applinks.css";

// /l/{code}: a short link Lens made. Reached only when the app is not
// installed, or the browser ignored the app link. Asks this environment's
// backend where the code leads (GET <api>links/{code} → {"target": …}) and
// replaces the address with it, so Back does not return here, keeping the
// short link's own utm_* where the target has none. An unknown code, an
// error, or a target off our own hosts goes to the home page.
//
// ON THE TEST SERVER (plain http on an IP address) the target is usually on
// the live website, and following it would take a tester off the test server
// to the live site. So there the code is still checked with this server's
// backend, and then the page offers the app (cinescape://l/{code}) and the
// same address on this server, rather than leaving. A target on this very
// site is followed as usual.
// docs/architecture/app-links-tracking-journeys.md §1.4 and §6.

const LOOKUP_TIMEOUT_MS = 10000;

function ShortLink({ match, config = APP_LINKS }) {
  const code = match.params.code;
  const [held, setHeld] = useState(null);

  useEffect(() => {
    let waiting = true;
    const go = (address) => {
      if (!waiting) return;
      waiting = false;
      replaceLocation(address);
    };

    if (!isShortCode(code)) {
      go("/");
      return undefined;
    }

    axios
      .get(Constants.api + "links/" + encodeURIComponent(code), { timeout: LOOKUP_TIMEOUT_MS })
      .then((res) => {
        const target = safeShortLinkTarget(res && res.data && res.data.target, window.location, config);
        if (!target) return go("/");
        const address = withShortLinkTracking(target, window.location.search);
        if (!shortLinkLeavesSite(address, window.location, config)) return go(address);
        if (!waiting) return undefined;
        waiting = false;
        return setHeld(onThisSite(address, window.location, config));
      })
      .catch(() => go("/"));

    return () => {
      waiting = false;
    };
  }, [code, config]);

  if (held) {
    return (
      <OpenInApp location={window.location} config={config} destination="short_link" websiteHref={held} />
    );
  }

  return (
    <div className="applinks-shortlink" role="status" aria-live="polite">
      <div className="applinks-spinner" aria-hidden="true" />
      <p>{isArabic() ? "جارٍ الفتح…" : "Opening…"}</p>
    </div>
  );
}

export default ShortLink;
